import React, { useContext, useState } from 'react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { useRouter } from 'next/router';
import { CourseContext } from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
import { Button, Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import FooterPortal from '@/modules/common/Portals/FooterPortal/FooterPortal';
import { getNextStep } from '@/modules/common/utils';
import { RegistrationStatus } from '@/modules/common/enums';
import ScoreCalculation from '../../components/ScoreCalculation/ScoreCalculation';
const Pass = () => {
  const [showScoreCalculation, setShowScoreCalculation] = useState<boolean>(false);
  const {
    courses,
    selectedCourseData
  } = useContext(CourseContext);
  const {
    registrationDetails,
    submitRegisterForm,
    isFormSubmitting
  } = useContext(RegistrationContext);
  const router = useRouter();
  const handleShowScoreCalculation = () => {
    setShowScoreCalculation(!showScoreCalculation);
  };
  return <article data-sentry-component="Pass" data-sentry-source-file="Pass.tsx">
      <div className="flex flex-wrap justify-between gap-2">
        <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="Pass.tsx">
          Entrance Exam Result
        </Typography>
        {!registrationDetails?.isEligibleForDirectAdmission ? <Button size="small" variant="lowFocus" onClick={handleShowScoreCalculation}>
            How is score calculated?
          </Button> : null}
      </div>
      <div className="relative p-5 border border-[#AAF0C4] bg-[#F6FEF9] rounded-lg flex gap-2 text-center items-center my-4">
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/14891fd2-e971-4577-8644-faab690c1ba8.png" alt="pass" width={120} height={120} className="absolute bottom-0 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
        <div className="flex flex-col items-center self-center gap-3 mx-auto text-center">
          <div>
            <Typography variant="heading3" weight="semi-bold" className="!text-sm sm:!text-lg" data-sentry-element="Typography" data-sentry-source-file="Pass.tsx">
              Well done! You have passed the exam.
            </Typography>
            <Typography variant="regular" className="!text-sm !text-[#757575]" data-sentry-element="Typography" data-sentry-source-file="Pass.tsx">
              Please find the CEE score below
            </Typography>
          </div>
          <div className="flex flex-col gap-8">
            <div className="flex self-center">
              <Typography variant="heading1" weight="bold" className="!text-[#099250] !text-4xl w-max h-max" data-sentry-element="Typography" data-sentry-source-file="Pass.tsx">
                {registrationDetails?.scaledScore}
                <span className="!text-[#757575] text-xs w-max h-max">
                  /{selectedCourseData?.maxScore || 184}
                </span>
              </Typography>
            </div>
            <div className="flex">
              <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/463c8efb-a28b-4967-bcd0-8d4a39551d1b.png" alt="pass" width={200} height={2} className="object-cover w-[100px] h-[2px] sm!:w-[200px]" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
              <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/3f12a6ea-8929-46bd-a426-8d3019d1ed77.png" alt="pass" width={30} height={30} data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
              <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/3f12a6ea-8929-46bd-a426-8d3019d1ed77.png" alt="pass" width={30} height={30} className="rotate-180" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
              <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/463c8efb-a28b-4967-bcd0-8d4a39551d1b.png" alt="pass" width={200} height={2} className="object-cover w-[100px] h-[2px] sm!:w-[200px]" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
            </div>
          </div>
        </div>
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/14891fd2-e971-4577-8644-faab690c1ba8.png" alt="pass" width={120} height={120} className="absolute bottom-0 right-4 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
      </div>

      <div className="h-8" />
      <div className="py-2">
        <FooterPortal label="Continue" type="button" btnWrapperClass="relative sm:left-[30%]" isFormSubmitting={isFormSubmitting} onClick={() => submitRegisterForm({
        step: getNextStep(router.query.step, registrationDetails?.step)
      }, true)} data-sentry-element="FooterPortal" data-sentry-source-file="Pass.tsx" />
      </div>

      {/* Score Calculation Dialog */}
      {showScoreCalculation && !registrationDetails?.isEligibleForDirectAdmission ? <ScoreCalculation onClose={handleShowScoreCalculation} /> : null}
    </article>;
};
export default Pass;